import Konva from "konva";
import type { PowerPointElement } from "./powerpoint-scene";
import { ART_HEIGHT, ART_WIDTH } from "../../lib/schedule-art/art-canvas";

export function renderPowerPointBackground(stage: Konva.Stage, elements: PowerPointElement[]) {
  const layer = new Konva.Layer({ listening: false });
  stage.add(layer);
  try {
    elements.forEach((element) => layer.add(element.node.clone()));
    const canvas = layer.toCanvas({ x: 0, y: 0, width: ART_WIDTH, height: ART_HEIGHT, pixelRatio: 1 });
    return canvas.toDataURL("image/png");
  } finally {
    layer.destroy();
  }
}
